import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function ConfirmLocalAlertPage() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code') || '';
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const confirm = async () => {
      if (!code) {
        setError('This confirmation link is missing its code.');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError('');
        const response = await fetch(`${API_BASE}/api/email-alerts/confirm?code=${encodeURIComponent(code)}`);
        const data = await response.json().catch(() => ({}));

        if (!response.ok || !data?.success) {
          throw new Error(data?.error || 'Unable to confirm local event alerts');
        }

        setSuccess(true);
        setMessage(data?.message || 'Local event alerts confirmed.');
      } catch (err: any) {
        setError(err?.message || 'Unable to confirm local event alerts');
      } finally {
        setLoading(false);
      }
    };

    confirm();
  }, [code]);

  return (
    <Box sx={{ maxWidth: 760, mx: 'auto', py: 5, px: 2 }}>
      <Card sx={{ borderRadius: 3 }}>
        <CardContent sx={{ p: { xs: 3, md: 4 } }}>
          <Stack spacing={2.5}>
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
                Confirm local event alerts
              </Typography>
              <Typography color="text.secondary">
                This confirms email alerts for new CrowdTrades events near your chosen location.
              </Typography>
            </Box>

            {loading ? (
              <Stack direction="row" spacing={1.5} alignItems="center">
                <CircularProgress size={22} />
                <Typography color="text.secondary">Confirming your alert...</Typography>
              </Stack>
            ) : success ? (
              <>
                <Alert severity="success">{message}</Alert>
                <Button component={RouterLink} to="/" variant="contained" sx={{ textTransform: 'none', width: 'fit-content' }}>
                  Back to CrowdTrades
                </Button>
              </>
            ) : (
              <>
                <Alert severity="error">{error || 'Unable to confirm local event alerts.'}</Alert>
                <Button component={RouterLink} to="/" variant="outlined" sx={{ textTransform: 'none', width: 'fit-content' }}>
                  Back to CrowdTrades
                </Button>
              </>
            )}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
